<script setup lang="ts">
import { Console } from "console";
import { ref } from "vue";
defineProps(["modelValue"]);
const emits = defineEmits(["update:modelValue", "input"]);
function emitChange(value) {
  emits("update:modelValue", value);
  emits("input", value);
}

window.addEventListener("click", handleClickOutside);
function handleClickOutside(event) {
  const passwordBox: HTMLElement | null =
    document.getElementById("first-password");
  if (passwordBox) {
    const firstChildElement = passwordBox.firstElementChild;
    if (firstChildElement instanceof HTMLElement) {
      if (firstChildElement && !firstChildElement.contains(event.target)) {
        firstChildElement.blur();
      }
    }
  }
}
// addEventListener("keypress", (e: KeyboardEvent) => {
//   if (e.code === "Enter") {
//     const passwordBox: HTMLElement | null =
//       document.getElementById("first-password");

//     if (passwordBox) {
//       const firstChildElement = passwordBox.firstElementChild;

//       if (firstChildElement instanceof HTMLInputElement) {
//         console.log(firstChildElement);
//         firstChildElement.blur();
//       }
//     }
//   }
// });
const passwordHidden = ref(true);
</script>
<template>
  <div class="flex align--center pos--rel">
    <input
      ref="passwordInput"
      class="font depixel normal color--black"
      name="password"
      :type="passwordHidden ? 'password' : 'text'"
      :value="modelValue"
      @input="emitChange(($event.target as HTMLInputElement).value)"
    />
    <span
      v-depixel
      class="pos--abs offset-r--s pointer"
      @click="passwordHidden = !passwordHidden"
    >
      {{ passwordHidden ? $t("global.show") : $t("global.hide") }}
      {{ $t("global.password").toLowerCase() }}
    </span>
  </div>
</template>
<style scoped lang="scss">
// KEEP IT SCOPED BRUV
// use :deep() to apply styles to the child component
/*
    .this-component:deep() { <- :deep() must be in parent node
        .child-component{ <- this has <style scoped> also defined

        }
    }
*/
</style>
